import { Card, Box, useTheme } from '@mui/material'
import { ErrorFallbackCardProps } from './ErrorFallbackCard.types'

export const ErrorFallbackCard = ({
  title,
  message,
  time,
  errorCodeLabel,
  errorCodeValue,
  errorDescriptionLabel,
  errorDescriptionValue,
}: ErrorFallbackCardProps) => {
  const theme = useTheme()

  return (
    <Card>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: theme.palette.secondary.main,
          color: theme.palette.secondary.contrastText,
          paddingTop: '48px',
          paddingBottom: '48px',
        }}
      >
        <Box
          sx={{
            fontSize: '50px',
            fontWeight: 800,
          }}
        >
          {title}
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: theme.palette.common.white,
          paddingTop: '48px',
          paddingLeft: '96px',
          paddingRight: '96px',
          paddingBottom: '96px',
        }}
      >
        <Box
          sx={{
            fontSize: '16px',
            paddingBottom: '32px',
            borderBottom: `1px solid ${theme.palette.grey[200]}`,
          }}
        >
          {message}
        </Box>
        <Box
          sx={{
            margin: '32px 0 16px 0',
            fontSize: '16px',
            fontWeight: 'bold',
          }}
        >
          {time}
        </Box>
        <Box
          sx={{
            backgroundColor: '#F5F6F7',
            padding: '32px',
            fontSize: '16px',
          }}
        >
          <Box>
            <Box component="span" sx={{ marginRight: '8px' }}>
              {errorCodeLabel}:
            </Box>
            <Box component="span" sx={{ color: theme.palette.error.main }}>
              {errorCodeValue}
            </Box>
          </Box>
          <Box component="span" sx={{ marginRight: '8px' }}>
            {errorDescriptionLabel}:
          </Box>
          <Box component="span"> {errorDescriptionValue}</Box>
        </Box>
      </Box>
    </Card>
  )
}
